import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {AuthEffects} from 'store/auth';
import {
  FormCard, FormCardHeader, Line, LinkContainer, SpanLink, StyledA, StyledLink
} from 'styles/styled';
import { motion } from 'framer-motion';
import {RootState} from '../../store';
import styled from "styled-components";
import {Colors, Spacing} from "styles/constants";
import {LogoSpinner} from "shared-react";
import {Routes} from "../../routes";
import {setInterval} from "timers";
import axios from "axios";
import {defaultMessageObj} from "../../util/constants";
import MessageCard from "../message-card";

const EmailCopy = styled.span`{
  font-weight: bold;
}`;

const ActionText = styled.h1 `{
  font-size: 36px;
  line-height: 36px;
  font-weight: 600;
  color: ${Colors.SlateDark};
  margin-bottom: ${Spacing.Space4};
}`;

const TextContainer = styled.div `{
  text-align: center;
  width: 100%;
  color: ${Colors.SlateDark};
  margin: ${Spacing.Space4} auto;
}`;

const VerifyEmail = () => {
  const [buttonClicked, setButtonClicked] = useState(false);
  const [errorMessage, setErrorMessage] = useState<JSX.Element | null>(null);
  const dispatch = useDispatch();
  const {email} = useSelector((state: RootState) => state.app.userInfo);
  const urlExtension = useSelector((state: RootState) => state.app.urlExtension);
  const isBusinessLogin = useSelector((state: RootState) => state.app.isBusinessLogin);

  const handleClick = () => {
      dispatch(AuthEffects.startVerifyEmail());
      setButtonClicked(true);
      setTimeout(() => setButtonClicked(false), 2000);
  }

  const returnToSignup = async () => {
    await dispatch(AuthEffects.startLogout());
    window.location.assign('/authenticate' + Routes.SIGNUP);
  }

  const returnToLogin = async () => {
    window.location.assign('/authenticate' + Routes.LOGIN);
  }

  useEffect(() => {
    const poll = setInterval(async () => {
      try{
        const {data: session} = await axios.get('/auth/session');
        if(!isBusinessLogin && session.verified) {
          window.location.assign('/authenticate' + Routes.SUCCESS_VERIFY_EMAIL + urlExtension);
          // dispatch(AuthActions.setVerifyingEmail(false));
        } else if (isBusinessLogin && session.isAuthenticated) {
          window.location.assign('/authenticate' + Routes.SUCCESS_VERIFY_EMAIL + urlExtension);
          // dispatch(AuthActions.setVerifyingEmail(false));
        }
      } catch (err) {
        setErrorMessage(<span>No longer listening for email verification in the background.</span>);
      }
    }, 10000);

    return () => {
      clearInterval(poll);
    }
  }, [isBusinessLogin, urlExtension])

  return (
    <>
        <FormCard>
          <FormCardHeader>Verifying account</FormCardHeader>
          <Line/>
          <MessageCard type={defaultMessageObj.type}>
            {errorMessage}
          </MessageCard>
          <ActionText>Check your Inbox</ActionText>
          <LogoSpinner/>
          <TextContainer>
            <p>We sent a verification email to <EmailCopy aria-label="user email">{email}</EmailCopy>.</p>
            <p>Open the link inside to continue.</p>
          </TextContainer>

        </FormCard>
        <LinkContainer>
          {!isBusinessLogin && (buttonClicked ? <ClickedCopy/> : <UnclickedCopy handleClick={handleClick}/>)}
          {isBusinessLogin ? <StyledA as="span" onClick={returnToLogin} aria-label='login link'>Return to login</StyledA> : <StyledA as='span' onClick={returnToSignup} aria-label='signup link'>Return to signup</StyledA>}
        </LinkContainer>
    </>
  );
};

const ClickedCopy = () => {
  return <motion.p>Email resent</motion.p>;
}

interface UnclickedProps {
  handleClick: any;
}

const UnclickedCopy = ({handleClick}: UnclickedProps) => {
  return <motion.p>Email didn't arrive? <SpanLink role="button" onClick={handleClick}>Resend link</SpanLink></motion.p>;
}

export default VerifyEmail;
